import Vue from 'vue';
import Router from 'vue-router';
import RegisterMeuFinanciamentoArisco from '@/views/meu-financiamento-arisco/RegisterMeuFinanciamentoArisco.vue';

Vue.use(Router);

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '*',
            name: '404',
            beforeEnter() {
                window.location.href = 'https://www.omni.com.br/404'; //TROCAR_ARISCO
            },
        },
        {
            path: '/',
            name: 'root',
            redirect: {
                name: 'register-meu-financiamento-arisco',
            },
        },
        {
            path: '/cadastro-meu-financiamento-arisco',
            name: 'register-meu-financiamento-arisco',
            component: RegisterMeuFinanciamentoArisco,
        },
    ],
});
